import React from 'react';
import { Avatar, DisplayText, ResourceItem } from '@superops/ui-design-system';

export default function UsersList(items, item, _, index) {
  const { userId, url, firstName, lastName } = item;
  const media = (
    <Avatar
      size="medium"
      name={firstName}
      initials={`${firstName[0]}${lastName?.[0] || ''}`}
    />
  );

  return (
    <ResourceItem
      id={userId}
      url={url}
      media={media}
      sortOrder={index}
      accessibilityLabel={`View details for ${firstName}`}
    >
      <div className='pt10'>
        <DisplayText element='h3' weight='SemiBold'>
          {firstName} {lastName}
        </DisplayText>
      </div>
    </ResourceItem>
  );
}
